export function scrollToId(id, opts = {}) {
  const el = document.getElementById(id);
  if (!el) return false;
  const offset = opts.offset ?? -60;
  const lenis = typeof window !== "undefined" ? window.__lenis : null;
  if (lenis && typeof lenis.scrollTo === "function") {
    lenis.scrollTo(el, { duration: 1.2, offset, ...opts });
  } else {
    const top = el.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({ top, behavior: "smooth" });
  }
  return true;
}

export function smoothClick(id, opts = {}) {
  return (e) => {
    if (scrollToId(id, opts)) {
      e.preventDefault();
      if (window.location.hash !== `#${id}`) {
        window.history.replaceState(null, "", `#${id}`);
      }
    }
  };
}
